import { makeAutoObservable, runInAction } from "mobx";
import { access_key, baseUrl } from "./main";

export default class Files {
  error = false;
  isLoading = false;
  passportFileSuccess = false;
  passportFile1Success = false;
  snilsFileSuccess = false;
  innFileSuccess = false;
  avatarFileSuccess = false;
  migration_cardFileSuccess = false;
  visaFileSuccess = false;
  open = false;
  openFiles = false;

  documentUrl = false;
  openModalDocument = false;

  constructor(instance) {
    this.rootStore = instance;
    makeAutoObservable(this, {}, { deep: true });
  }

  cleanFilesSuccess = () => {
    this.passportFileSuccess = false;
    this.passportFile1Success = false;
    this.snilsFileSuccess = false;
    this.innFileSuccess = false;
    this.avatarFileSuccess = false;
    this.migration_cardFileSuccess = false;
    this.visaFileSuccess = false;
  };

  setDocumentUrl = (value) => {
    this.documentUrl = value;
  };
  setOpenModalDocument = (value) => {
    this.openModalDocument = value;
  };

  openFilesInProfile = (value) => {
    this.openFiles = value;
  };

  sendFile = async (value) => {
    if (!value.id) {
      runInAction(() => {
        this.error = true;
        this.isLoading = false;
      });
      return;
    }
    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("candidate_id", value.id);
    bodyData.append("file_name", value.file_name);
    bodyData.append("file", value.file);

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/setdata?action=files_add`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => {
            this.error = true;
            this.isLoading = false;
          });
        }
      })
      .then((response) => {
        runInAction(() => {
          const prev = this.rootStore.candidatesStore.oneCandidateFiles || {};
          this.rootStore.candidatesStore.oneCandidateFiles = {
            ...prev,
            [value.file_name]: response["file_path"]
          };
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };

  deleteFile = async (value) => {
    this.isLoading = true;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("agent_id", value.id);
    bodyData.append("file_name", value.file_name);

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/setdata?action=files_remove`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => {
            this.error = true;
            this.isLoading = false;
          });
        }
      })
      .then(() => {
        runInAction(() => {
          this.rootStore.usersStore.getUserData({
            newToken: this.rootStore.usersStore.token
          });
          switch (value.file_name) {
            case "passport":
              this.passportFileSuccess = "remove";

              break;
            case "passport1":
              this.passportFile1Success = "remove";

              break;
            case "inn":
              this.innFileSuccess = "remove";

              break;
            case "snils":
              this.snilsFileSuccess = "remove";

              break;
            case "avatar":
              this.avatarFileSuccess = "remove";

              break;
            case "migration_card":
              this.migration_cardFileSuccess = "remove";

              break;
            case "visa":
              this.visaFileSuccess = "remove";

              break;
            default:
              break;
          }
          this.isLoading = false;
          this.open = true;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };

  sendAgentFile = async (value) => {
    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("agent_id", value.id);
    bodyData.append("file_name", value.file_name);
    bodyData.append("file", value.file);

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/setdata?action=files_add`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => {
            this.error = true;
          });
        }
      })
      .then((response) => {
        runInAction(() => {
          this.rootStore.usersStore.userFiles[value.file_name] =
            response["file_path"];
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
        });
      });
  };

  setApproved = (approved) => {
    runInAction(() => (this.rootStore.usersStore.userData[approved] = "0"));
  };
}
